import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as reducks from '../../../reducks'
import FlameSantander from '../../commons/Icons/FlameSantander'
import Text from '../../commons/Text/Text'
import ExternalLayout from '../../commons/Layouts/ExternalLayout'
import LoginForm from './LoginForm'
import styles from './login.module.scss'

const LoginContainer = () => {
  const dispatch = useDispatch()
  const handleSubmit = (data) =>
    dispatch(reducks.resources.session.actions.preLogin(data))
  const error = useSelector((state) => state.sessionReducer.content.error)

  return (
    <ExternalLayout>
      <div className={styles.container}>
        <div className={styles.logoSantander}>
          <FlameSantander />
        </div>
        <Text
          className={styles.contentOne}
          color="gray"
          variation="dark"
          size="lg"
          bold
          inline
          margin="10px 0px"
        >
          Amplie sua presença e resultados.
        </Text>
        <Text
          className={styles.contentTwo}
          color="gray"
          variation="dark"
          size="md"
          margin="10px 0px"
        >
          Atue com eficiência e visão estratégica, acompanhe o seu cliente
          diariamente e aumente os seus ganhos.
        </Text>
      </div>
      <div className={styles.form}>
        <LoginForm handleSubmit={handleSubmit} error={error} />
      </div>
    </ExternalLayout>
  )
}

export default LoginContainer
